import React from 'react'
function Services() {

  
  return (
 


    <section class="about-us-area pt-90 pb-120">
        
        <div class="container">
            <div class="row">
                <div class="col-lg-6" >
                    <div class="section-title  mb-45 fadeInDown" >
                        <span>ETAP 1</span>
                        <h2>Podpisanie <span>umowy</span></h2>
                    </div>
                    <div class="about-content">
                        <p>Na początku współpracy zawierana jest formalna umowa pomiędzy naszą firmą a Firmą (partnerem biznesowym), która określa warunki realizacji zleceń dotyczących montażu i serwisowania lokalizatorów GPS.</p>
                    </div>
                </div>
                <div class="col-lg-6 leftorder" id="first-row">
                    <div class=" mb-45 fadeInDown" data-aos="" >
                        <img src="assets/img/images/shake.png" class="img-fluid " alt=""/>
                    </div>
                </div>

            </div>
            <br/>

            <div class="row">
                <div class="col-lg-6">
                    <div class=" mb-45 fadeInDown" data-aos="">
                        <img src="assets/img/images/email.png" class="img-fluid " alt=""/>
                    </div>
                </div>
                <div class="col-lg-6 ">
                    <div class="section-title  mb-45 fadeInDown">
                        <span>ETAP 2</span>
                        <h2>Informacja o <span> rodzaju usługi</span></h2>
                    </div>
                    <div class="about-content">
                        <p>Firma przesyła nam lokalizator GPS do montażu u klienta lub informuje nas o potrzebie przeprowadzenia naprawy istniejącego urządzenia bezpośrednio u klienta.</p>
                    </div>
                </div>
            </div>

            <br/>

            <div class="row">
                <div class="col-lg-6 ">
                    <div class="section-title mb-45 fadeInDown" >
                        <span>ETAP 3</span>
                        <h2> Realizacja<span> usługi</span></h2>
                    </div>
                    <div class="about-content">
                        <p>Spotykamy się z klientem w ustalonym terminie, aby przeprowadzić montaż lokalizatora GPS lub dokonać wymaganej naprawy urządzenia. Cała operacja jest przeprowadzana zgodnie z ustalonymi standardami jakości i bezpieczeństwa.</p>
                    </div>
                </div>
                <div class="col-lg-6 leftorder">
                    <div class=" mb-45 fadeInDown" data-aos="">
                        <img src="assets/img/images/service.png" class="img-fluid " alt=""/>
                    </div>
                </div>

            </div>

<br/>


            <div class="row">
                <div class="col-lg-6">
                    <div class=" mb-45 fadeInDown" data-aos="">
                        <img src="assets/img/images/report.png" class="img-fluid " alt=""/>
                    </div>
                </div>
                <div class="col-lg-6 ">
                    <div class="section-title  mb-45 fadeInDown" >
                        <span>ETAP 4</span>
                        <h2>Raportowanie <span>usługi</span></h2>
                    </div>
                    <div class="about-content">
                        <p>Po pomyślnym zakończeniu montażu lub naprawy lokalizatora GPS, informujemy Firmę o zrealizowaniu zlecenia, dostarczając szczegółowy raport dotyczący wykonanych prac.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

  )
}

export default Services